export default {
  header: 'Sumar comandă',
  buttons: {
    checkout: 'Plată securizată',
    continue: 'Continuă',
    add_products: '+ Adaugă produse',
    add_items: '+ Adaugă mai multe articole',
    menu: 'Meniu',
  },
  empty_order_basket: {
    description: 'Coșul tău este gol <br/> Adaugă articole pentru a începe',
  },
  promo_code_banner: {
    single_use: '{{discount}} reducere - {{code}}',
    multi_use: '{{discount}} reducere pentru {{count}} comenzi - {{code}}',
    redeem: 'VALORIFICĂ',
    redeemed: 'VALORIFICAT',
  },
  upsell: {
    title: 'Oamenii mai comandă și',
  },
  rewards: {
    title: 'Plătește cu puncte',
    description: '<highlight>Autentifică-te</highlight> pentru a plăti cu puncte',
  },
  already_member: 'Ești deja membru?',
  sign_in: 'Autentifică-te',
  summary: {
    subtotal: 'Subtotal',
    delivery: 'Livrare',
    pickup: 'Ridicare',
    total: 'Total',
    free: 'Gratuit',
  },
  footer: {
    member_earning: '+{{points}} pts după finalizare · sold {{balance}} pts',
    guest_earning: 'Înregistrează-te pentru a câștiga puncte la această comandă',
  },
};
